export function validarIIBB(iibb = []) {
  const errors = [];
  iibb.forEach((ret, i) => {
    const importe = parseFloat(ret.importe);

    if (importe > 0 || ret.provincia_id) {
      if (!ret.provincia_id) {
        errors.push(`Retención IIBB ${i + 1}: debe seleccionar la provincia`);
      }

      if (isNaN(importe) || importe <= 0) {
        errors.push(`Retención IIBB ${i + 1}: el importe debe ser mayor a 0`);
      }
    }
  });

  const provinciasUsadas = iibb
    .filter((r) => r.provincia_id && parseFloat(r.importe) > 0)
    .map((r) => r.provincia_id);

  const set = new Set();
  const duplicadas = new Set();

  provinciasUsadas.forEach((prov) => {
    if (set.has(prov)) duplicadas.add(prov);
    else set.add(prov);
  });

  if (duplicadas.size > 0) {
    errors.push(
      "No puede haber retenciones IIBB duplicadas para la misma provincia",
    );
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}
